import { defineComponent, reactive, watch } from '@vue/composition-api'
import RichUtil from '@/pages/Survey/components/RichUtil/index.vue'
import { getTopicOptions, changeOptionValue } from '../../util'
import { STR_TYPE } from '../../config'
import _ from 'lodash'
import { getMinMaxValue } from '../../topicCommonUtil'
import { tran } from '@/utils/assist'
import OptionSettings from '../../../SurveyDetail/compontents/optionSettings'
import CommonTetxEdit from '@/components/CommonTetxEdit'

const MultiLineEdit = defineComponent({
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  setup(props, context) {
    const { emit } = context
    const state = reactive({
      editItem: _.cloneDeep(props.item) //编辑数据源
    })
    watch(
      () => state.editItem,
      (val) => {
        emit('changeTopicContent', val)
      },
      {
        deep: true
      }
    )
    return () => {
      return (
        <div class="topic-edit-content">
          <div class="topic-edit-content-item topic-edit-content-title">
            {!state.editItem.isAddStatus && (
              <div class="topic-edit-content-title-order">
                {!state.editItem.topicSetting.isAllowNull && <i>*</i>}
                {state.editItem.order}.
              </div>
            )}
            <div style={{ width: '100%' }}>
              <CommonTetxEdit
                needDynamicEvent
                initialData={state.editItem.topicName}
                placeholder= {tran('survy.mulLineName')}
                handleUpdate={(value) => {
                  state.editItem.topicName = value
                }}
              />
            </div>
          </div>
          <div class="topic-edit-content-item">
            <CommonTetxEdit
              needDynamicEvent
              initialData={state.editItem.topicSetting.topicRemark}
              placeholder={tran('survy.plcremark')}
              handleUpdate={(value) => {
                state.editItem.topicSetting.topicRemark = value
              }}
            />
          </div>

          <div class="topic-edit-content-item">
            <el-input type="textarea" autosize={true} resize="none"></el-input>
          </div>
          <div class="topic-edit-content-item">
            <CommonTetxEdit
              needDynamicEvent={true}
              initialData={state.editItem.topicSetting.endword}
              placeholder={tran('survy.mulLineend')}
              handleUpdate={(value) => {
                state.editItem.topicSetting.endword = value
              }}
            />
          </div>
          <Portal to="survey-option-settings">
            <OptionSettings
              type={props.item.topicType}
              isAllowNull={state.editItem.topicSetting.isAllowNull}
              textLessThan={state.editItem.topicSetting.textLessThan}
              onChangeIsAllowNull={(value) => {
                state.editItem.topicSetting.isAllowNull = value
              }}
              onChangeTextLessThan={(value) => {
                state.editItem.topicSetting.textLessThan = getMinMaxValue(
                  value,
                  1000
                )
              }}
            />
          </Portal>
        </div>
      )
    }
  }
})

export default MultiLineEdit
